<template>
 <v-col :cols="col" :sm="mdcol" :class="link? 'sponsor-image': 'sponsor-image-nolink'" >
    <a :href="link" target="_blank">  
      <v-card elevation="0" class="pa-0">
        <v-img
          :alt="name"
          class="rsidebg namecard fill-height"
          contain
          :src="require('../../assets/sponsors23/p_sponsor_bg.png')"
          width="100%"
        >
        <v-container fill-height fluid class="pa-0 px-sm-2 px-md-3">
          <v-row justify="center" v-if="mdcol>3 || $vuetify.breakpoint.smAndUp && mdcol==3">
            <v-img
              contain
              :src="require('../../assets/sponsors23/ornaments_top.png')"
              max-width="35%"
            />
          </v-row>
          <v-row no-gutters justify="center" align="center">
            <span :class=namesize >{{name}}</span>
          </v-row>
          <v-row justify="center" v-if="mdcol>3 || $vuetify.breakpoint.smAndUp && mdcol==3" >
            <v-img
              contain
              :src="require('../../assets/sponsors23/ornaments_bottom.png')"
              max-width="35%"
            />
          </v-row>
        </v-container>

          <!--overlay-->
          <v-row class="overlay" no-gutters align="center">
            <v-col align="center" >
              <v-icon color="white" large>mdi-open-in-new</v-icon>
            </v-col>
          </v-row>
        </v-img>
        <v-card-title class="py-2 px-1">
          <h6 class="wdgt-subtitle liiblack--text text--lighten-1 mb-0 sponsor-name">{{name}}</h6>
        </v-card-title>
      </v-card>
    </a> 
  </v-col>
</template>


<script>
  export default {
    name:'SponsorCardIndi',
    props:{           
      name: String, //sponsor name
      link: String, //link to donor
      mdcol: String,
      col: String,
    },
    computed:{
      namesize(){
        if(this.mdcol==6){
          return 'personal-sponsor-name tier1-name text--liiblack text--lighten-1'
        }else if(this.mdcol==4){
          return 'personal-sponsor-name tier2-name text--liiblack text--lighten-1'
        }else{
          return 'personal-sponsor-name tier3-name text--liiblack text--lighten-1'
        }
      },
    }
  }
</script>


<style scoped>
  a{
    text-decoration: none;
  }

  .sponsor-image:hover ::v-deep .sponsor-name a{
    text-decoration: underline;
    text-underline-offset: 1px;
    color: var(--v-liiblack-lighten2);
  }
  
  .sponsor-image-nolink a {
    cursor: default;
  }

  .overlay {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100%;
    width: 100%;
    opacity: 0;
    background-blend-mode: color-burn;
    transition: .3s ease;
    background-color: transparent;
  }
  .sponsor-image:hover .overlay {
    opacity: 1;
    background-color: rgba(142, 0, 18, 0.3);
  }

  .sponsor-name{
    line-height: 1.15em;
  }
  .personal-sponsor-name{
    font-family: 'Noto Serif';
    font-weight: 600;
    text-align: center;
    display: block;
  }

  .tier1-name{
    font-size: 2.4em;
    line-height: 1.2em;
  }
  .tier2-name{
    font-size: 1.28em;
    line-height: 1.15em;
  }
  .tier3-name{
    font-size: 0.9em;
    line-height: 1.2em;
  }

  .ornament{
    display: table-cell;
  }
  .ornament-parent{
    overflow: visible;
  }
</style>